// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SubHeader_wrap_2tmaU","subheaderMobile":"SubHeader_subheaderMobile_2jEU9","link":"SubHeader_link_1200E"};